import { ReactNode } from "react";
import styles from './styles/Content.module.css'

export default function Content({ children }: { children: ReactNode }) {
    return (
        <div className={styles.content}>{children}</div>
    )
}